import { bind } from '@/registration_teaser/bind'

bind()
